import {
  isRangeFractionVFrame,
  type RangeFractionVFrame,
} from '@festina/life-general-types/life'
import { notEmpty } from '@festina-life/core'
import {
  FormikPercentageInput,
  type FormikPercentageInputProps,
} from '@festina-life/ui/formikForms'
import { usePercentageFormatter } from '@festina-life/ui/hooks'
import get from 'lodash-es/get'

import { isFieldRequired } from '../../forms/formUtility'
import { useLifeFormikContext } from '../../forms/useLifeFormikContext'
import {
  isDontUseVFrame,
  isFixedVFrame,
} from '../../forms/yup/validation/types'
import { isVFrameWithDefaultValue } from '../../forms/yup/validation/yupValidationUtils'
import { useFieldVFrame } from '../useFieldVFrame'
import type { InputPropsFromFormik } from './types'

export type LifPercentageInputProps =
  InputPropsFromFormik<FormikPercentageInputProps>

export const LifePercentageInput = ({
  name,
  disabled,
  ...restProps
}: LifPercentageInputProps) => {
  const { formatPercentWithDecimals } = usePercentageFormatter()

  const { values, setFieldValue } = useLifeFormikContext()
  const frameStatus = useFieldVFrame(name)

  if (isDontUseVFrame(frameStatus)) {
    return null
  }

  const value = get(values, name as string)
  const isFixed = isFixedVFrame(frameStatus)
  const isRequired = isFieldRequired(frameStatus)

  const getValue = () => (isFixed ? frameStatus.value : value)

  const defaultValue = isVFrameWithDefaultValue(frameStatus)
    ? (frameStatus as RangeFractionVFrame)?.defaultValue
    : null

  const [min, max] =
    frameStatus && isRangeFractionVFrame(frameStatus)
      ? [frameStatus.min, frameStatus.max]
      : [undefined, undefined]

  const validationText =
    notEmpty(min) || notEmpty(max)
      ? `${formatPercentWithDecimals(min)}–${formatPercentWithDecimals(max)}`
      : undefined

  return (
    <FormikPercentageInput
      name={name}
      disabled={isFixed || disabled}
      isRequired={isRequired}
      defaultValue={defaultValue ?? undefined}
      validationText={validationText}
      onDefaultValueClick={() => setFieldValue(name, defaultValue)}
      hasRightColumnAlways
      {...restProps}
      value={getValue()}
    />
  )
}
